import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../../../../services/auth.service';
import {RegistryService} from '../../../services/registry.service';

@Component({
  selector: 'app-customer-registration',
  templateUrl: './customer-registration.component.html',
  styleUrls: ['./customer-registration.component.css']
})
export class CustomerRegistrationComponent implements OnInit , OnDestroy{

  status = null;

  userLoggedEvent;
  customerLoadedEvent;
  userLoggedOutEvent;

  constructor(private registry: RegistryService, private authService: AuthService) {

    this.userLoggedEvent = this.authService.UserLoggedInEvent$.subscribe(customer => {

      this.status = 'loggedin';

    });

    this.customerLoadedEvent = this.registry.CustomerLoadedEvent$.subscribe(customer => {

      this.status = 'loggedin';

    });
    this.userLoggedOutEvent = this.authService.UserLoggedOutEvent$.subscribe(() => {

      this.status = null;

    });
  }

  ngOnInit(): void {
  }
  ngOnDestroy(): void {
    this.userLoggedEvent.unsubscribe();
    this.customerLoadedEvent.unsubscribe();
    this.userLoggedOutEvent.unsubscribe();

  }

}
